import { ReactNode } from 'react';
import { useProfile } from '@/hooks/useProfile';
import PaywallModal from '@/components/PaywallModal';
import FloatingSupportWidget from '@/components/FloatingSupportWidget';

interface RequireActiveProps {
  children: ReactNode;
}

export default function RequireActive({ children }: RequireActiveProps) {
  const { isAuthenticated, loading } = useProfile();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

    // If authenticated, show protected content with floating support widget
    if (isAuthenticated) {
      return (
        <>
          <FloatingSupportWidget />
          {children}
        </>
      );
    }

    // If not authenticated, redirect to unlock page
    window.location.href = '/auth';
    return null;
}